import "core-js/modules/es.promise.js";
/**
 * @param fn - pass null to set a generic await
 * @param timeoutMs time to wait before firing the callback function
 **/
export var awaitableSetTimeout = (fn, timeoutMs) => new Promise((resolve, reject) => {
  setTimeout(() => {
    try {
      fn && fn(); //calling the callback function
      resolve();
    } catch (error) {
      reject();
    }
  }, timeoutMs);
});